module.exports = __webpack_public_path__ + "img/07.5923c35e.webp";